module.exports = __webpack_public_path__ + "img/i_nav_home_new_off.c8f788e3.svg";